import { render, staticRenderFns } from "./PayoneerTopUpForm.vue?vue&type=template&id=056f940d&scoped=true&"
import script from "./PayoneerTopUpForm.vue?vue&type=script&lang=js&"
export * from "./PayoneerTopUpForm.vue?vue&type=script&lang=js&"
import style0 from "./PayoneerTopUpForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PayoneerTopUpForm.vue?vue&type=style&index=1&id=056f940d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056f940d",
  null
  
)

export default component.exports